angular.module('impactx.rfx').controller('RFXItemCompareCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'ToolbarService',
    '$mdDialog',
    '$route',
    RFXItemCompareCtrl
]);

function RFXItemCompareCtrl($scope, $routeParams, dataGen, ToolbarService, $mdDialog, $route) {
    var self = this;
    dataGen.getData($scope, {rfqiGroupId: $routeParams.rfqiGroupId}, '/rfx/itemcompare/view').then(function () {
        ToolbarService.setButtons([]);
    });

    self.openCommentDialog = function(event, item){
        $mdDialog.show({
            controller: 'RFXItemCompareCommentCtrl',
            controllerAs: 'rfxItemCompareCommentCtrl',
            templateUrl: 'modules/rfx/templates/rfxitemcomparecomment.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                item: item,
                trns: $scope.trns
            }
        });
    };

    self.openValueDialog = function(event, item){
        $mdDialog.show({
            controller: 'RFXItemCompareValueCtrl',
            controllerAs: 'rfxItemCompareValueCtrl',
            templateUrl: 'modules/rfx/templates/rfxitemcomparevalue.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                item: item,
                trns: $scope.trns
            }
        }).then(function () {
            $route.reload();
        });
    };
}